import makeList from './makeList.js'

let viewFloor = '情報処理棟'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '情報処理棟入口',
        file: './data/I12e.JPG',
        rotation: 113.9549406821425,
        link: [
          {
            file: './data/I12c.JPG',
            position: [ 1734.7919879625551, 2695.922232096931, -3831.7450185811786 ],
          },
          {
            file: './data/I12.JPG',
            position: [ -4481.023035001792, 1809.358772432819, 1248.2370381235082 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 340.4255319148936, 262.41134751773046 ],
          syowaZoom: [ 228.20512820512823, 482.2307692307694 ],
        },
      },
      { description: '情報処理棟(1)',
        file: './data/I12a.JPG',
        rotation: -3.271897895887008,
        link: [
          {
            file: './data/I12b.JPG',
            position: [ 4954.001788699734, 191.25409390956094, 592.1572532421571 ],
          },
          {
            file: './data/I12c.JPG',
            position: [ 3865.742260540045, -99.67965770429387, 3154.1813047082296 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 340.4255319148936, 262.41134751773046 ],
          syowaZoom: [ 387.17948717948724, 318.1282051282054 ],
        },
      },
      { description: '情報処理棟(2)',
        file: './data/I12b.JPG',
        rotation: -28.930825220513654,
        link: [
          {
            file: './data/I12a.JPG',
            position: [ -4762.450752565202, -314.21081872363567, 1470.69914528829 ],
          },
          {
            file: './data/I12c.JPG',
            position: [ -198.91520998799137, 269.9571034040832, 4978.9686464331235 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 340.4255319148936, 262.41134751773046 ],
          syowaZoom: [ 274.35897435897436, 307.87179487179503 ],
        },
      },
      { description: '情報処理棟(3)',
        file: './data/I12c.JPG',
        rotation: 431.7962266986908,
        link: [
          {
            file: './data/I12a.JPG',
            position: [ -2992.413963716615, 196.46768125089835, -3991.8522218246935 ],
          },
          {
            file: './data/I12b.JPG',
            position: [ -2222.432347168789, 389.2399526138131, -4454.4142911820845 ],
          },
          {
            file: './data/I12d.JPG',
            position: [ 4648.206040427785, 461.0015949721728, 1758.4176050812189 ],
          },
          {
            file: './data/I12e.JPG',
            position: [ 2892.0513639148376, 1140.143567872652, 3912.443123390885 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 340.4255319148936, 262.41134751773046 ],
          syowaZoom: [ 256.4102564102564, 389.92307692307725 ],
        },
      },
      { description: '情報処理棟(4)',
        file: './data/I12d.JPG',
        rotation: -17.514214891593838,
        link: [
          {
            file: './data/I12c.JPG',
            position: [ -4687.330663252641, 1422.9131244738855, -981.5772194215211 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 340.4255319148936, 262.41134751773046 ],
          syowaZoom: [ 115.3846153846154, 415.5641025641029 ],
        },
      },
      /*
       */
    ],
  },
]

export default makeList(params,viewFloor)
